import { FC, useCallback, useEffect, useRef } from "react";
import { DotLottieReact, type DotLottie } from "@lottiefiles/dotlottie-react";
import { MDSLoadingArrowsProps, MDSLoadingArrowsSize } from "./loading-arrows.types";
import { StyledLoadingArrowsContainer } from "./loading-arrows.styles";
import loadingArrowsAnimation from "@/assets/images/loading-arrows-tomato.json";

export const MDSLoadingArrows: FC<MDSLoadingArrowsProps> = ({
  size = MDSLoadingArrowsSize.Medium,
  className,
  loop = true,
  speed = 1.0,
}) => {
  const dotLottieRef = useRef<DotLottie | null>(null);

  const handleDotLottieRef = useCallback((dotLottie: DotLottie | null) => {
    dotLottieRef.current = dotLottie;
  }, []);

  useEffect(() => {
    const dotLottie = dotLottieRef.current;

    if (!dotLottie) {
      return;
    }

    dotLottie.setLoop(loop);

    if (loop) {
      dotLottie.play();
    }
  }, [loop]);

  return (
    <StyledLoadingArrowsContainer size={size} className={className}>
      <DotLottieReact
        data={loadingArrowsAnimation}
        loop={loop}
        autoplay={loop}
        dotLottieRefCallback={handleDotLottieRef}
        speed={speed}
        style={{ width: "100%", height: "100%" }}
      />
    </StyledLoadingArrowsContainer>
  );
};
